import Vue from 'vue'

export const mutations = {

    commonStartLoading(state) {
        state.loading = true
    },

    commonEndLoading(state) {
        state.loading = false
    },

    toggleSidebar(state) {
        state.closeSidebar = !state.closeSidebar;
    },

    setPageTitle(state, data) {
        state.pageTitle = data
    },

    setNazioni(state, data) {
        state.nazioni = data
    },

    setProvincie(state, data) {
        state.provincie = data
    },

    setCitta(state, data) {
        state.citta = data
    },

    setBreadcrumbActive(state, data) {
        const newState = state.breadcrumb;
        newState.map((item) => {
            if (item.active) {
                item.text = data;
            }
        });

        Vue.set(state.breadcrumb, 'newProp', newState);
    },

    resetState(state) {
        state.loading = false;
        state.pageTitle = '';
        state.breadcrumb = [];
        state.nazioni = [];
        state.provincie = [];
        state.citta = [];
    },

};
